var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBacktotop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 25,
    fill: "#FFBF3A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 34.2016L29.3169 25L30.794 25L40 34.2053L39.2525 34.9963L30.3577 26.1038L29.7496 26.1038L20.7439 35L20 34.2016Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBacktotop);
export default __webpack_public_path__ + "static/media/backtotop.5ad1ef2ee17d9e2cf43d477638b29c6a.svg";
export { ForwardRef as ReactComponent };